// extracted by css-extract-rspack-plugin
export default {"root":"root-fww_iM","content":"content-mj8M3x","label":"label-WKxh6d text-sm-medium"};